import React from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StudioPageShell from '../../components/studio/StudioPageShell';
import StudioV2ExtensionsPanel from '../../components/studio/StudioV2ExtensionsPanel';

/** Primary + advanced tabs (legacy aliases map in the panel). */
const TABS = new Set([
  'plugins', 'installed', 'skills', 'tools',
  'advanced', 'builder', 'marketplace', 'sideload', 'audit',
]);

export default function StudioExtensionsPage() {
  const [params] = useSearchParams();
  const tab = params.get('tab');
  const initialTab = TABS.has(tab) ? tab : undefined;
  return (
    <StudioPageShell
      title="Extensions"
      subtitle="Plugins, skills, and tools for this workspace"
      backTo="/studio"
      actions={(
        <Button
          component={RouterLink}
          to="/studio/help/extensions"
          size="small"
          startIcon={<HelpOutlineIcon />}
          sx={{ textTransform: 'none' }}
        >
          Help
        </Button>
      )}
    >
      <StudioV2ExtensionsPanel initialTab={initialTab} />
    </StudioPageShell>
  );
}
